import React from 'react';
import {Typography} from '@material-ui/core';
import {FormattedMessage, useIntl} from 'react-intl';
import Title from 'components/Title';
import Content from 'components/Content';
import {Helmet} from 'react-helmet-async';
import useStyles from './DisclaimerPage.styles';

export default function () {
    let classes = useStyles();
    let intl = useIntl();

    return (
        <div className={classes['root']}>
            <Helmet>
                <title>
                    {intl.formatMessage({
                        id: 'meta.DisclaimerPage.title',
                    })}
                </title>
                <meta
                    name="description"
                    content={intl.formatMessage({
                        id: 'meta.DisclaimerPage.description',
                    })}
                />
            </Helmet>
            <Title
                title={
                    <FormattedMessage
                        id="pages.DisclaimerPage.pageTitle"
                        defaultMessage={`Disclaimer`}
                    />
                }
            />
            <Content component="article">
                <Typography
                    variant="body2"
                    component="p"
                >
                    <strong>
                        This website is provided “as is” without any representations or warranties, express or implied. Direct
                        Basing B.V. makes no representations or warranties in relation to this website or the information and materials
                        provided on this website.
                    </strong>
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Content
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    The information on this website provided by Direct Basing® B.V. is derived from sources that may be considered reliable.
                    However, the completeness and correctness cannot be guaranteed. The information on the website is solely indicative and
                    may be altered by Direct Basing® B.V. without any notice.
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Accountability
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    The provided information is by no means legally binding. Direct Basing® B.V. cannot guarantee a faultless and
                    uninterrupted functioning website. Direct Basing® B.V. is by no means responsible for the content of the website, nor
                    the
                    information provided on the website. Direct Basing® B.V. cannot be held accountable for the content of sites that have
                    been developed by Direct Basing® B.V. and are referred to on the website, nor the websites who are referring to Direct
                    Basing B.V..
                </Typography>
                <Typography
                    variant="h4"
                    component="h2"
                >
                    Responsibility
                </Typography>
                <Typography
                    variant="body2"
                    component="p"
                >
                    The recipient of the information is responsible for the selection and use of the provided information. The information
                    can solely be used by the customer himself. Customers may not transfer, reproduce, edit or disseminate the information
                    provided by Direct Basing® B.V.. Customers are required to follow guidelines provided by Direct Basing® B.V. on the
                    usage
                    of information. Regarding the content of the website no replication rights exists, all copyright, including those
                    referred to in Article 15 of the Dutch Copyright Law are reserved. Dutch law applies.
                </Typography>
            </Content>
        </div>
    );
}
